module.exports = __webpack_public_path__ + "img/pr-7.266dc3d6.png";